import styled from 'styled-components';

import ExportModalContents from 'components/ExportModalContents';

export const ModalContents = styled(ExportModalContents)`
  width: 570px;
`;
